import request from '@/router/axios'
import qs from 'qs'

// 首页
export const homeApi = {
  // 获取轮播图
  fetchSwiper: (obj) => {
    return request({
      url: '/pchome/index',
      method: 'post',
      data: qs.stringify(obj)
    })
  },
  //  获取移动端轮播图
  fetchMobileSwiper: (obj) => {
    return request({
      url: '/pchome/getBanner',
      method: 'post',
      data: qs.stringify(obj)
    })
  }
}

// 加入我们
export const joinUsApi = {
  fetchJobList: (obj) => {
    return request({
      url: '/pchome/joinList',
      method: 'post',
      data: qs.stringify(obj)
    })
  }
}
